import { makeAutoObservable, runInAction } from 'mobx'
import type { ReCAPTCHA } from 'react-google-recaptcha'
import { logger } from 'shared/lib'

export const statusReCaptchaV2 = {
  error_1: 'error_re_captcha_not_load',
  error_2: 'error_re_captcha_not_token',
  error_3: 'error_re_captcha_other',
}

export class ReCaptchaV2Store {
  private _token = ''
  private _api: ReCAPTCHA | null = null
  private _error = ''

  constructor() {
    makeAutoObservable(this)
  }

  get token() {
    return this._token
  }

  initToken = async (): Promise<string> => {
    if (!this._api) {
      this._token = ''
      this.setError(statusReCaptchaV2.error_1)

      return this._token
    }

    try {
      this._api.reset()

      const token = await this._api.executeAsync()

      runInAction(() => {
        this._token = token || ''

        if (!this._token) {
          this.setError(statusReCaptchaV2.error_2)
        } else {
          this.setError('')
        }
      })

      return token || ''
    } catch (e) {
      runInAction(() => {
        this.setError(statusReCaptchaV2.error_3)
        this._token = ''
      })

      throw e
    }
  }

  get error() {
    return this._error
  }

  setError = (value: string) => {
    logger.error(value)

    this._error = value
  }

  setToken = (value: string) => {
    this._token = value
  }

  setApi = (value: ReCAPTCHA) => {
    this._api = value
  }
}
